interface AdminSongPreviewButtonProps {
  songId: string;
  playing: boolean;
  loading: boolean;
  onClick: () => void;
}

export function AdminSongPreviewButton({ songId, playing, loading, onClick }: AdminSongPreviewButtonProps) {
  const label = loading ? "Chargement…" : playing ? "Arrêter" : "Écouter";
  const icon = loading ? "…" : playing ? "■" : "▶";

  return (
    <button
      type="button"
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-medium transition-colors ${
        playing
          ? "bg-orange-500/25 text-orange-200 hover:bg-orange-500/35"
          : "bg-violet-500/20 text-violet-200 hover:bg-violet-500/35"
      }`}
      title={label}
      aria-label={`${label} ${songId}`}
      disabled={loading}
      onClick={onClick}
    >
      <span aria-hidden="true">{icon}</span>
      {label}
    </button>
  );
}
